import { Fragment, useState } from 'react';

import ReactSelect from 'react-select';
import * as Yup from 'yup';

import { Form, Select } from '../../../../../Components/Form';
import Loading from '../../../../../Components/Loading/Loading';
import ModalCustom from '../../../../../Components/Modal/ModalCustom';
import RemoveModal from '../../../../../Components/Modal/RemoveModal';
import { useApi } from '../../../../../Hooks/Api';
import { useToast } from '../../../../../Hooks/Toast';
import GymModal from './GymModal';

const validationSchema = Yup.object({
  // name: Yup.string().required("نام تیم الزامی است"),
});

const validationSchemaZ = Yup.object({
  name: Yup.string().required('نام تیم الزامی است'),
});

const TeamList = ({ context, teamAddUserLoaidng, errors }) => {
  const { post, get, put } = useApi();
  const { error, success } = useToast();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modaRemoveOpen, setModalRemoveOpen] = useState(false);
  const [modalRemoveUserOpen, setModalRemoveUserOpen] = useState(false);
  const [modalRemoveObject, setModalRemoveObject] = useState({});
  const [loading, setLoading] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [searchTeam, setSearchTeam] = useState(true);
  const [searchLoading, setSearchLoading] = useState(false);
  const [zModalIsOpen, setZModalIsOpen] = useState(false);
  const [searchZLoading, setSearchZLoading] = useState(false);
  const [editTeam, setEditTeam] = useState(false);
  const [userModalObject, setUserModalObject] = useState({});
  const [teamModalObject, setTeamModalObject] = useState({});

  const searchTeamSubmit = async (values) => {
    setSearchLoading(true);
    await post(
      '/team/search',
      values,
      (res) => {
        context.team = res.data;
        if (Object.entries(res?.data?.length == 0)) {
          success(
            'تیم مورد نظر قبلا ثبت نشده است برای ثبت بر روی دکمه افزودن کلیک کنید.',
          );
        }
        setSearchTeam(false);
        setSearchLoading(false);
      },
      (err) => {
        error('جستجوی اطلاعات با خطا مواجه شد لطفا مجددا امتحان کنید.');
        setSearchLoading(false);
      },
    );
  };

  const createTeam = async (values) => {
    setLoading(true);
    setSearchLoading(true);
    if (Object.entries(context?.team)?.length > 0) {
      await addTeamToList(context?.team);
      context.team = {};
      setLoading(false);
      setSearchTeam(true);
      setSearchLoading(false);
      setModalIsOpen(false);
      return;
    }

    await post(
      '/team',
      values,
      (res) => {
        let teams = context.teams;
        teams.push(res.data);
        context.team = {};
        setSearchTeam(true);
        setLoading(false);
        setSearchLoading(false);
        setModalIsOpen(false);
      },
      (err) => {
        error('تیم به علت خطا ثبت نشد');
        setLoading(false);
        setSearchLoading(false);
      },
    );
  };

  const addTeamToList = (team) => {
    const teams = context?.teams;
    let teamIndex = teams.findIndex((t) => t.id === team.id);
    if (teamIndex !== -1) {
      return error('تیم قبلا به لیست شما اضافه شده است.');
    }

    teams.push(team);
    context.teams = teams;
  };

  const editUser = (name, value, teamId, userId) => {
    const teams = [...context.teams];
    let team = teams.findIndex((t) => t.id === teamId);
    let users = teams[team]?.users;
    let user = users?.findIndex((u) => u?.id === userId);
    // if (name === "age_id") {
    //   let age = context?.competition?.ages?.find((a) => a.id == value);
    //   let range = moment(user?.birthday).isBetween(
    //     moment(age?.start_age),
    //     moment(age?.end_age),
    //   );
    //   if (!range)
    //     return error("رده سنی انتخاب شده با رده سنی شرکت کننده یکسان نیست");
    // }
    users[user][name] = value;
    teams[team][users] = users;
    context.teams = teams;
  };

  const addGymToUser = () => {
    const teams = [...context.teams];
    let team = teams.findIndex((t) => t.id === userModalObject?.team?.id);
    let users = teams[team]?.users;
    let user = users?.findIndex((u) => u?.id === userModalObject?.user?.id);
    users[user]['gym'] = context?.gym;
    teams.users = users;
    context.teams = teams;
    context.gym = {};
    setZModalIsOpen(false);
  };
  // const updateTeam = async (values) => {
  //   setSearchLoading(true);
  //   setLoading(true);
  //   put(
  //     `/team/${teamModalObject?.id}`,
  //     values,
  //     (res) => {
  //       const teams = [...context.teams];
  //       let team = teams.findIndex((t) => t.id === teamModalObject?.id);
  //       teams[team] = res.data;
  //       context.teams = teams;
  //       setTeamModalObject({});
  //       setEditTeam(false);
  //       setSearchLoading(false);
  //       setLoading(false);
  //       setModalIsOpen(false);
  //       success("تیم با موفقیت ویرایش شد.");
  //     },
  //     (err) => {
  //       error("تیم به علت خطا ویرایش نشد.");
  //       setSearchLoading(false);
  //       setLoading(false);
  //     },
  //   );
  // };

  const removeTeam = async (id) => {
    setLoading(true);
    setRemoveLoading(true);
    const teams = [...context.teams];
    let teamsFilter = await teams.filter((t) => t.id != id);
    context.teams = teamsFilter;
    setModalRemoveOpen({});
    setRemoveLoading(false);
    setLoading(false);
    setModalRemoveOpen(false);
    success('تیم با موفقیت از لیست حذف شد');
  };

  const removeUserToLeague = async (userId) => {
    setLoading(true);
    setRemoveLoading(true);
    const teams = [...context.teams];
    let teamIndex = await teams.findIndex(
      (t) => t.id == modalRemoveObject?.team?.id,
    );
    let usersFilter = teams[teamIndex]?.users?.filter(
      (u) => u.id != modalRemoveObject?.user?.id,
    );
    teams[teamIndex].users = usersFilter;
    context.leagues = teams;
    setModalRemoveObject({});
    setRemoveLoading(false);
    setLoading(false);
    setModalRemoveUserOpen(false);
    success('کاربر با موفقیت از تیم حذف شد');
  };

  return (
    <>
      <div className='col-12 my-3'>
        <div className='d-flex flex-row justify-content-between align-items-center my-3'>
          <div className='d-flex flex-row align-items-center'>
            <i className='far fa-layer-group f-18 text-dark'></i>
            <span className='text-dark f-14 font-weight-bold mx-2'>
              لیست تیم ها
            </span>{' '}
          </div>
          {context.teams?.length === 0 && (
            <i
              className='far fa-plus f-20 c-pointer mx-2 text-dark'
              onClick={() => {
                setEditTeam(false);
                setTeamModalObject({});
                setModalIsOpen(true);
              }}
            ></i>
          )}
        </div>
        {loading ? (
          <Loading />
        ) : (
          <>
            {context?.teams?.length > 0 ? (
              <>
                {context?.teams?.map((team) => (
                  <Fragment key={'team-' + team?.id}>
                    <div className='d-flex flex-row justify-content-between align-items-center border-bottom border-dark pb-3'>
                      <div className='d-flex flex-row align-items-center mt-1'>
                        <span className='text-dark f-14 font-weight-bold'>
                          نام تیم :{' '}
                        </span>
                        <span className='text-dark f-14 font-weight-bold mx-2'>
                          {team?.name}
                        </span>
                      </div>
                      <div className='d-flex flex-row align-items-center'>
                        {/* <i
                          className='far fa-edit text-info f-18 mx-2 c-pointer'
                          title='ویرایش تیم'
                          onClick={() => {
                            setEditTeam(true);
                            setTeamModalObject(team);
                            setModalIsOpen(true);
                          }}
                        ></i> */}
                        <i
                          className='far fa-trash f-20 c-pointer mx-2 text-danger'
                          onClick={() => {
                            setModalRemoveObject(team);
                            setModalRemoveOpen(true);
                          }}
                        ></i>
                      </div>
                    </div>
                    {team?.users?.length > 0 ? (
                      <table className='table table-striped my-3 text-left'>
                        <thead>
                          <tr className='bg-purple text-white'>
                            <th scope='col'>#</th>
                            <th scope='col'></th>
                            <th scope='col'>کد ملی</th>
                            <th scope='col'>استان محل زندگی</th>
                            <th scope='col'>زورخانه</th>
                            <th scope='col'>رشته</th>
                            {context.competition?.weights?.length > 0 && (
                              <th scope='col'>وزن</th>
                            )}
                            <th scope='col'>رده سنی</th>
                            <th scope='col'>حذف</th>
                          </tr>
                        </thead>
                        <tbody>
                          <>
                            {teamAddUserLoaidng ? (
                              <Loading />
                            ) : (
                              <>
                                {team.users?.map((user, index) => (
                                  <tr key={'team-user-' + user?.id}>
                                    <th scope='row'>{index + 1}</th>
                                    <td>
                                      {user?.name} {user?.last_name}
                                    </td>
                                    <td>{user?.national_card_id}</td>
                                    <td>{user?.province_living?.name}</td>
                                    <td>
                                      <div className='d-flex flex-row align-items-center justify-content-between'>
                                        <span className='text-dark f-13 mt-1'>
                                          {user?.gym?.name ??
                                            'زور خانه ای ثبت نشده'}
                                        </span>
                                        <i
                                          onClick={() => {
                                            setUserModalObject({ user, team });
                                            setZModalIsOpen(true);
                                          }}
                                          className='far fa-edit text-info f-16 mx-2 c-pointer'
                                          title='اضافه یا ویرایش زورخانه'
                                        ></i>
                                      </div>
                                    </td>
                                    <td>
                                      {/* <select
                                        defaultValue={user?.sport_id}
                                        className='form-control'
                                        onChange={(e) =>
                                          editUser(
                                            "sport_id",
                                            e.target.value,
                                            team?.id,
                                            user?.id
                                          )
                                        }
                                      >
                                        <option readonly={true}>
                                          انتخاب کنید
                                        </option>
                                        {context?.competition?.sports?.map(
                                          (sport) => (
                                            <option value={sport.id}>
                                              {sport?.title}
                                            </option>
                                          )
                                        )}
                                      </select> */}
                                      <ReactSelect
                                        defaultValue={user?.sport_id ?? []}
                                        isMulti
                                        options={context?.competition?.sports?.filter(
                                          (s) =>
                                            s?.type === 0 ||
                                            s?.type === 2 ||
                                            s?.type === 4 ||
                                            s?.type === 6,
                                        )}
                                        onChange={(value) => {
                                          editUser(
                                            'sport_id',
                                            value,
                                            team?.id,
                                            user?.id,
                                          );
                                        }}
                                        noOptionsMessage={() =>
                                          `رشته ای جهت انتخاب یافت نشد!`
                                        }
                                        isOptionDisabled={() => {
                                          const teamFind = context?.teams?.find(
                                            (t) => t?.id == team?.id,
                                          );
                                          const userFind =
                                            teamFind?.users?.find(
                                              (u) => u?.id == user?.id,
                                            );
                                          return (
                                            userFind?.sport_id?.length >=
                                            context?.competition
                                              ?.sport_count_select
                                          );
                                        }}
                                        getOptionLabel={(s) => s?.title}
                                        getOptionValue={(s) => s?.id}
                                        closeMenuOnSelect={false}
                                        classNamePrefix='text-left justify-content-start w-100'
                                        placeholder='انتخاب کنید...'
                                      />
                                    </td>
                                    {context.competition?.weights?.length >
                                      0 && (
                                      <td>
                                        <select
                                          className='form-control'
                                          defaultValue={user?.weight_id}
                                          onChange={(e) =>
                                            editUser(
                                              'weight_id',
                                              e.target.value,
                                              team?.id,
                                              user?.id,
                                            )
                                          }
                                        >
                                          <option readonly={true}>
                                            انتخاب کنید
                                          </option>
                                          {context?.competition?.weights?.map(
                                            (weight) => (
                                              <option value={weight.id}>
                                                {weight?.weight}
                                              </option>
                                            ),
                                          )}
                                        </select>
                                      </td>
                                    )}
                                    <td>
                                      <select
                                        className='form-control'
                                        defaultValue={user?.age_id}
                                        onChange={(e) =>
                                          editUser(
                                            'age_id',
                                            e.target.value,
                                            team?.id,
                                            user?.id,
                                          )
                                        }
                                      >
                                        <option readonly={true}>
                                          انتخاب کنید
                                        </option>
                                        {context?.competition?.ages?.map(
                                          (age) => (
                                            <option value={age.id}>
                                              {age?.title}
                                            </option>
                                          ),
                                        )}
                                      </select>
                                      {errors?.team?.teamUserErrors?.[
                                        `user.age_id.${user?.id}`
                                      ]?.length > 0 && (
                                        <span className='text-danger f-11 my-2'>
                                          {
                                            errors?.team?.teamUserErrors?.[
                                              `user.age_id.${user?.id}`
                                            ]
                                          }
                                        </span>
                                      )}
                                    </td>
                                    <td>
                                      <i
                                        className='fal fa-trash text-danger f-18 c-pointer'
                                        onClick={() => {
                                          setModalRemoveObject({
                                            team: team,
                                            user: user,
                                          });
                                          setModalRemoveUserOpen(true);
                                        }}
                                      ></i>
                                    </td>
                                  </tr>
                                ))}
                              </>
                            )}
                          </>
                        </tbody>
                      </table>
                    ) : (
                      <div className='d-flex flex-row justify-content-center align-items-center my-3'>
                        اطلاعاتی جهت نمایش یافت نشد.
                      </div>
                    )}
                  </Fragment>
                ))}
              </>
            ) : (
              <div className='d-flex flex-row justify-content-center align-items-center my-3'>
                اطلاعاتی جهت نمایش یافت نشد.
              </div>
            )}
          </>
        )}
      </div>
      <ModalCustom modalIsOpen={modalIsOpen}>
        <Form
          initialValues={{
            // name: editTeam ? teamModalObject?.name : "",
            province_id: editTeam ? teamModalObject?.province?.id : '',
          }}
          validationSchema={validationSchema}
          defaultActions={false}
          onSubmit={
            searchTeam && !editTeam
              ? searchTeamSubmit
              : !searchTeam && !editTeam
              ? createTeam
              : null
          }
        >
          <div className='row'>
            <div className='col-12'>
              <div className='d-flex flex-row justify-content-start align-items-center border-bottom border-white'>
                <h1 className='text-white f-14 font-weight-bold'>
                  {editTeam
                    ? `ویرایش تیم ${teamModalObject?.name}`
                    : 'افزودن تیم'}
                </h1>
              </div>
            </div>
            {/* <div className='col-12 col-md-6'>
              <Text
                title='نام تیم'
                name='name'
                labelclassName='text-white my-2'
              />
            </div> */}
            <div className='col-12'>
              <Select
                name='province_id'
                title='استان'
                labelclassName='text-white my-2'
                options={context?.competition?.provinces}
                optionLabel='name'
                optionValue='id'
              />
            </div>
            {context?.team?.name !== undefined || editTeam ? (
              <div className='col-12 p-2 rounded-1 my-3 bg-sky-light'>
                <div className='d-flex flex-column'>
                  <h1 className='text-dark f-14 font-weight-bold line-height-2'>
                    {editTeam
                      ? 'در صورتی که نیاز به ویرایش تیم می باشد لطفا اطلاعات را وارد و برروی ویرایش تیم کلیک کنید'
                      : '  تیم درخواستی قبلا در سیستم ثبت شده است در صورت صحیح بودن تیمرا انتخاب نمایید و در غیر اینصورت تیم جدیدی با نام جدید ثبتکنید :'}
                  </h1>
                </div>
                <div className='d-flex flex-row align-items-center justify-content-around my-3'>
                  <div className='d-flex flex-row align-items-center'>
                    <span className='text-dark font-weight-bold f-13 mx-2'>
                      نام تیم :{' '}
                    </span>
                    <span className='text-dark font-weight-bold f-13 mx-2'>
                      {editTeam ? teamModalObject?.name : context?.team?.name}
                    </span>
                  </div>
                  <div className='d-flex flex-row align-items-center'>
                    <span className='text-dark font-weight-bold f-13 mx-2'>
                      استان :{' '}
                    </span>
                    <span className='text-dark font-weight-bold f-13 mx-2'>
                      {editTeam
                        ? teamModalObject?.province?.name
                        : context?.team?.province?.name}
                    </span>
                  </div>
                </div>
              </div>
            ) : null}

            <span
              className='btn bg-danger text-white f-13 ml-3 c-pointer'
              onClick={() => {
                setSearchTeam(true);
                setModalIsOpen(false);
              }}
            >
              انصراف
            </span>
            {searchTeam && !editTeam ? (
              <>
                {searchLoading ? (
                  <button className='btn bg-info text-white f-13 mx-2'>
                    <div
                      className='spinner-border text-white spinner-border-sm mb-1'
                      role='status'
                    >
                      <span className='sr-only'></span>
                    </div>
                  </button>
                ) : (
                  <button className='btn bg-info text-white f-13 mx-2'>
                    جستجو
                  </button>
                )}
              </>
            ) : (
              <>
                {searchLoading ? (
                  <button className='btn bg-info text-white f-13 mx-2'>
                    <div
                      className='spinner-border text-white spinner-border-sm mb-1'
                      role='status'
                    >
                      <span className='sr-only'></span>
                    </div>
                  </button>
                ) : (
                  <>
                    {editTeam ? (
                      <button
                        type='submit'
                        className='btn bg-info text-white f-13 mx-2'
                      >
                        ویرایش تیم
                      </button>
                    ) : (
                      <>
                        {searchLoading ? (
                          <button className='btn bg-info text-white f-13 mx-2'>
                            <div
                              className='spinner-border text-white spinner-border-sm mb-1'
                              role='status'
                            >
                              <span className='sr-only'></span>
                            </div>
                          </button>
                        ) : (
                          <button
                            type='submit'
                            className='btn bg-info text-white f-13 mx-2 c-pointer'
                          >
                            افزودن تیم
                          </button>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </Form>
      </ModalCustom>

      <GymModal
        addGymToUser={addGymToUser}
        context={context}
        setZModalIsOpen={setZModalIsOpen}
        zModalIsOpen={zModalIsOpen}
        team={true}
        setEditTeam={setEditTeam}
        setTeamModalObject={setTeamModalObject}
      />
      <RemoveModal
        id={modalRemoveObject?.id}
        modalIsOpen={modaRemoveOpen}
        removeItem={removeTeam}
        removeLoading={removeLoading}
        setModalIsOpen={setModalRemoveOpen}
        title={`آیا از حذف تیم "${modalRemoveObject?.name}" مطمئن هستید؟`}
      />

      <RemoveModal
        id={modalRemoveObject?.id}
        modalIsOpen={modalRemoveUserOpen}
        removeItem={removeUserToLeague}
        removeLoading={removeLoading}
        setModalIsOpen={setModalRemoveUserOpen}
        title={`آیا از حذف کاربر "${modalRemoveObject?.user?.name} ${modalRemoveObject?.user?.last_name}" مطمئن هستید؟`}
      />
    </>
  );
};

export default TeamList;
